import { type ResourceState, ResourceType, type Resource, ResourceSearchResult } from '../resources/types';

export type Callback = () => void;
export type ResourceReference = Resource | number;

export type LibraryContextType = {
  focusedIndex: number,
  setFocusedIndex: React.Dispatch<React.SetStateAction<number>>,
  searchQuery: string,
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>,
  typeFilter: TypeFilterFunction,
  setTypeFilter: React.Dispatch<React.SetStateAction<TypeFilterFunction>>,
  searchboxRef: React.MutableRefObject<HTMLInputElement | null>,
  resources: ResourceState,
  filteredResources: ResourceSearchResult[],
  // Actions
  previewResource: (res: ResourceReference, callback?: Callback) => void,
  addResourceToPlaylist: (res: ResourceReference, callback?: Callback) => void,
  sendResourceToLive: (res: ResourceReference, callback?: Callback) => void,
};

export type TypeFilterFunction = (resource: Resource) => boolean;

export const TypeFilter: Record<string, TypeFilterFunction> = {
  ALL: () => true,
  SONGS: (r) => r.type === ResourceType.SONG,
  LITURGY: (r) => r.type === ResourceType.LITURGY
};
